import {
  defaultFont,
  primaryColor,
  dangerColor,
  grayColor,
  successColor,
  warningColor
} from "assets/jss/material-dashboard-react.js";
import tooltipStyle from "assets/jss/material-dashboard-react/tooltipStyle.js";
import checkboxAdnRadioStyle from "assets/jss/material-dashboard-react/checkboxAdnRadioStyle.js";
const tasksStyle = {
  ...tooltipStyle,
  ...checkboxAdnRadioStyle,

  inputUpload: {
    display: "none",
  },
  close: {
    backgroundColor: "transparent",
    color: dangerColor[0],
    boxShadow: "none"
  },
  edit: {
    backgroundColor: "transparent",
    color: primaryColor[0],
    boxShadow: "none"
  },
  edit2: {
    backgroundColor: "transparent",
    color: "#FFFFFF",
    boxShadow: "none"
  },
  edit3: {
    backgroundColor: "transparent",
    color: "#000000",
    boxShadow: "none"
  },
  edit4: {
    backgroundColor: successColor[0],
    color: "#ffffff",
    boxShadow: "none"
  },
  edit5: {
    backgroundColor: "transparent",
    color: "#1022ef",
    boxShadow: "none"
  },
  edit6: {
    backgroundColor: "transparent",
    color: "#0f14bc",
    boxShadow: "none"
  },
  edit7: {
    backgroundColor: "transparent",
    color: "#FF0000",
    boxShadow: "none"
  },
  edit8: {
    backgroundColor: "transparent",
    color: successColor[0],
    boxShadow: "none"
  },
  labelInputUpload: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "#000000",
    backgroundColor: "transparent",
    padding: "10px",
    border: "none",
    borderBottom: "1px solid #000000",
    cursor: "pointer",
  },
  marginT: {
    marginBottom: "20px"
  },
  /* table: {
     marginBottom: "0",
     overflow: "visible"
   },*/
  table: {
    backgroundColor: "transparent",
    color: warningColor[2],
    boxShadow: "none"
  },
  tableRow: {
    position: "relative",
    borderBottom: "1px solid " + grayColor[5]
  },
  tableActions: {
    display: "flex",
    border: "none",
    padding: "12px 8px !important",
    verticalAlign: "middle"
  },
  tableCell: {
    ...defaultFont,
    padding: "8px",
    verticalAlign: "middle",
    border: "none",
    lineHeight: "1.42857143",
    fontSize: "14px"
  },
  tableCellRTL: {
    textAlign: "right"
  },
  transfer: {
    float: "right"
  },
  tableActionButton: {
    width: "27px",
    height: "27px",
    padding: "0"
  },
  tableActionButtonIcon: {
    width: "17px",
    height: "17px"
  },
  tableActionButtonIcon2: {
    color: "#4169e1",
    width: "17px",
    height: "17px"
  },
  tableActionButtonIconArrow: {
    width: "35px",
    height: "35px"
  },
  tableActionButtonIconDownload: {
    width: "21px",
    height: "35px"
  },
  tableActionButtonIconResolve: {
    width: "40px",
    height: "40px"
  },

  view: {
    backgroundColor: "transparent",
    color: successColor[0],
    boxShadow: "none"
  },

};
export default tasksStyle;
